import type { CompanyFilters } from "../../types";
import type { RankingsSlice } from "./slice";

export function toCompanyFilters(
  slice: RankingsSlice
): Partial<CompanyFilters> {
  return {
    ...(slice.fortune500 && { fortune500: true }),
    ...(slice.forbes2000 && { forbes2000: true }),
  };
}

export function fromCompanyFilters(filters: CompanyFilters): RankingsSlice {
  return {
    fortune500: filters.fortune500 === true,
    forbes2000: filters.forbes2000 === true,
  };
}
